import { render, staticRenderFns } from "./onion_skin_viewer.vue?vue&type=template&id=5a4671c8&"
import script from "./onion_skin_viewer.vue?vue&type=script&lang=js&"
export * from "./onion_skin_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports